import { render } from "./Sales_Reps.vue?vue&type=template&id=a6c6b982&scoped=true"
import script from "./Sales_Reps.vue?vue&type=script&lang=js"
export * from "./Sales_Reps.vue?vue&type=script&lang=js"

import "./Sales_Reps.vue?vue&type=style&index=0&id=a6c6b982&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6c6b982"]])

export default __exports__